import { AnimationBuilder, createAnimation } from '@ionic/angular/standalone';

/**
 * Simple routing animation horizontally slides the pages in and out.
 * Animates the entire page, rather than specific individual elements like the defaults do.
 */
export const routerAnimation: AnimationBuilder = (baseEl, opts) => {
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;
  const backDirection = opts.direction === 'back';

  const duration = 400;
  const animation = createAnimation()
    .addElement(enteringEl)
    .duration(duration) // Increase the duration here (in milliseconds)
    .easing('ease-in-out')
    .fromTo('opacity', '1', '1')
    .fromTo('transform', backDirection ? 'translateX(-100vw)' : 'translateX(100vw)', 'translateX(0)');

  if (leavingEl) {
    const leavingAnimation = createAnimation()
      .addElement(leavingEl)
      .duration(duration) // Ensure the leaving animation matches
      .easing('ease-in-out')
      .fromTo('opacity', '1', '1')
      .fromTo('transform', 'translateX(0)', backDirection ? 'translateX(100vw)' : 'translateX(-100vw)');

    return createAnimation().addAnimation([animation, leavingAnimation]);
  }

  return animation;
};
